module.exports = __webpack_public_path__ + "img/smallWeibo.21f66eef.png";